import { action, makeAutoObservable, observable } from 'mobx'
import { ClassicStakeConfig, ClassicStakeUserConfig } from 'views/Stake/classicStake.logic'

export enum StakeProgress {
  INITIAL,
  PENDING,
  APPROVING,
  CONFIRMING,
  SUCCESS,
  ERROR,
  REJECTED
}

export class StakeStore {
  constructor() {
    makeAutoObservable(this)
  }

  @observable
  stakeProgress: StakeProgress = StakeProgress.INITIAL

  @observable
  stake: ClassicStakeConfig

  @observable
  staker: ClassicStakeUserConfig | null = null

  @observable
  txHash: string

  @observable
  error = undefined

  @action
  setStakeProgress(progress: StakeProgress) {
    this.stakeProgress = progress
  }

  @action
  setTxHash(txHash: string) {
    this.txHash = txHash
  }

  @action
  setError(errorCode: any) {
    this.error = errorCode
  }

  @action
  setStake(stake: ClassicStakeConfig) {
    this.stake = stake
  }

  @action
  setStaker(staker: ClassicStakeUserConfig) {
    this.staker = staker
  }

  @action
  resetStakeStore() {
    this.stakeProgress = StakeProgress.INITIAL
    this.txHash = ''
    this.error = undefined
    this.staker = null
    this.stake = null
  }
}

export const stakeStore = new StakeStore()
